import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { getStoredHomeRoute } from '@core/home/home-route-local-storage';

export const homeRedirectToStoredRouteGuard: CanActivateFn = () => {
  const router = inject(Router);
  return router.parseUrl(`/home/${getStoredHomeRoute()}`);
};
